/**
 * 로그인, 로그아웃의 API를 정의 - 쿠키 기반 인증
 *
 * @author bart <bart@ymjlab.com>
 * @version 2.0.0
 * @since 2025-06-02 - 쿠키 방식으로 변경
 */
import instance from "./instance";
import { LoginRequestDto, LoginResponseDto } from "@/dto/AdmDto";
import { ResponseDto } from "@/dto/ResponseDto";
import { ENV } from "@/constants/env";

// 🔥 instance.ts의 baseURL이 http://localhost:3050이므로 PREFIX를 포함해야 함
const PREFIX_PATH = `${ENV.PRE_FIX}/${ENV.ADMIN_PATH}`;

/**
 * 슈퍼어드민 로그인 요청 (쿠키 방식)
 *
 * @param {LoginRequestDto} data
 * @returns {Promise<LoginResponseDto>}
 */
export const login = async (
  data: LoginRequestDto
): Promise<LoginResponseDto> => {
  console.log("🔐 슈퍼어드민 로그인 API 호출:", data);
  const result = await instance.post(`${PREFIX_PATH}/auth/login`, data);
  console.log("✅ 슈퍼어드민 로그인 API 응답:", result);
  return result as unknown as LoginResponseDto;
};

/**
 * 슈퍼어드민 로그아웃 요청 (쿠키 방식)
 *
 * @returns {Promise<ResponseDto>}
 */
export const logout = async (): Promise<ResponseDto> => {
  console.log("🚪 슈퍼어드민 로그아웃 API 호출");
  const result = await instance.post(`${PREFIX_PATH}/auth/logout`);
  console.log("✅ 슈퍼어드민 로그아웃 API 응답:", result);
  return result as unknown as ResponseDto;
};
